@if (resAsync | async) {
  <div #selectorContainer class="pathSelector">
    <button mat-icon-button class="buttonCancelPath" (click)="cancel()">
      <mat-icon [svgIcon]="res.svgName('Close-Image')"></mat-icon>
    </button>
    <p class="helpText">{{ res.get('Controls-PathSelector-HelpText', res.get('Controls-PathSelector-Object')) }}</p>
    <button (click)="close()" class="buttonReady">{{ res.get('Done') }}</button>
  </div>
}
